var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('card-header',{attrs:{"event-message":_vm.eventMessage,"close-action":_vm.closedChat}}),_c('card-body'),_c('card-footer',{attrs:{"send-message":_vm.sendMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }